import { Record } from 'immutable';

import trainTime from '../lib/TrainTime';
import { resolve } from '../helpers/LinkMapper';
import { SeasonCustomRange } from '../constants/AppConstants';
const timeUnits = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];

const anchor = {
    endDate: 'endDate',
    duration: 'duration'
};

const defaults = {
    startDate: null,
    endDate: null,
    duration: 0,
    unit: 'days',
    anchor: anchor.duration,
    min: SeasonCustomRange.MIN,
    max: SeasonCustomRange.MAX
};

class CustomDuration extends Record(defaults) { // eslint-disable-line new-cap

    setStartDate (startDate) {
        startDate = trainTime.isTrainTime(startDate) ? startDate.clone() : trainTime(startDate);
        let self = this.set('startDate', startDate);

        if (this.anchor === anchor.endDate) {
            return self.setEndDate(self.endDate);
        } else if (this.anchor === anchor.duration) {
            return self.setDuration(self.duration);
        }
        return self;
    }

    getStartDate () {
        return this.startDate && this.startDate.clone();
    }

    setEndDate (endDate) {
        endDate = trainTime.isTrainTime(endDate) ? endDate.clone() : trainTime(endDate);
        endDate = this.getConstrainedEndDate(endDate);

        let self = this.set('endDate', endDate);
        if (self.startDate) {
            const duration = endDate.calendarDuration(self.startDate).add(1, self.unit);
            self = self.set('duration', duration);
        }
        return self.set('anchor', anchor.endDate);
    }

    getEndDate () {
        return this.endDate && this.endDate.clone();
    }

    setDuration (duration, ...args) {
        duration = trainTime.isDuration(duration) ? duration : trainTime.duration(duration, ...args);
        duration = this.getConstrainedDuration(duration);
        let self = this.set('duration', duration);

        if (self.startDate) {
            let endDate = self.addDuration(self.startDate, duration);

            self = self.set('endDate', endDate.subtract(1, self.unit));
        }
        return self.set('anchor', anchor.duration);
    }

    formatDuration () {
        return this.duration.toJSON();
    }

    getDuration () {
        return trainTime.duration({
            years: this.duration.years(),
            months: this.duration.months(),
            days: this.duration.days()
        });
    }

    getConstrainedDuration (duration) {
        let { min, max } = this;
        if (min) {
            min = trainTime.duration(min);
            if (duration.asMilliseconds() <= min.asMilliseconds()) {
                return min;
            }
        }

        if (max) {
            max = trainTime.duration(max);
            if (duration.asMilliseconds() >= max.asMilliseconds()) {
                return max;
            }
        }

        return duration;
    }

    getConstrainedEndDate (endDate) {
        if (this.startDate) {
            const duration = this.getConstrainedDuration(
                endDate.calendarDuration(this.startDate).add(1, this.unit)
            );
            endDate = this.addDuration(this.startDate, duration).subtract(1, this.unit);
        }
        return endDate;
    }

    addDuration (date, duration) {
        return timeUnits.reduce((acc, unit) => acc.add(duration.get(unit), unit), date.clone());
    }
}

CustomDuration.fromJSON = function (json = {}) {
    const obj = new CustomDuration({
        startDate: resolve(json.startDate).with(trainTime),
        unit: resolve(json.unit).with(String),
        anchor: resolve(json.anchor).with(String)
    });

    if (json.anchor === anchor.duration) { return obj.setDuration(json.duration, obj.unit); }
    if (json.anchor === anchor.endDate) { return obj.setEndDate(json.endDate); }
    return null;
};

export default CustomDuration;



// WEBPACK FOOTER //
// ./src/records/CustomDuration.js